<template>
  <div class="afdc-row">
    <div :class="isNpsFunded ? 'afdc-col-md-8' : 'afdc-col-md-6'">
      <div class="afdc-row afdc-no-gutters">
        <div :class="isNpsFunded ? 'afdc-col-md-12' : 'afdc-col-md-6 afdc-location-inputs-col'">
          <div class="afdc-row afdc-no-gutters">
            <div v-if="isNpsFunded" class="afdc-col-md-7 afdc-park-check">
              <nps-filter />
            </div>
            <div :class="isNpsFunded ? 'afdc-col-md-5' : 'afdc-col-md-12'">
              <div class="afdc-form-group">
                <div v-if="isNpsFunded && !isMobileView" class="afdc-custom-control afdc-custom-checkbox afdc-nps-checkbox">
                  <input type="checkbox" class="afdc-custom-control-input" v-model="queryAccess" v-bind:value="'private'" :id="'parkShowPrivate'" >
                  <label class="afdc-custom-control-label" :for="'parkShowPrivate'">{{ $t('Include private stations') }}</label>
                </div>

                <label class="afdc-sr-only" for="afdc-location">{{ $t('Location') }}</label>
                <div class="afdc-input-group">
                  <input v-model="queryLocationLive" v-on:change="triggerQueryLocationChange" type="text" class="afdc-form-control afdc-clearable-input" id="afdc-location" v-bind:placeholder="$t('Enter location')">

                  <div v-if="queryLocationLive" :class="{'afdc-clear-input':true, 'afdc-mobile-clear':isMobileView}" v-on:click="clearLocation">
                    <span class="afdc-sr-only">{{ $t('Clear location') }}</span>
                    <font-awesome-icon icon="times-circle" class="afdc-fa-icon"/>
                  </div>

                  <div class="afdc-input-group-append" v-if="!isMobileView">
                    <button class="afdc-btn afdc-btn-secondary" type="submit" v-bind:aria-label="$t('Search')"><font-awesome-icon icon="search" class="afdc-fa-icon"/></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!isNpsFunded" class="afdc-col-md-6">
          <find-fuel-filter/>
        </div>
      </div>
    </div>

    <div :class="isNpsFunded ? 'afdc-col-md-4' : 'afdc-col-md-6'">
      <div class="afdc-row afdc-h-100" v-if="$route.name!=='CorridorStations'">
        <div class="afdc-col-md">
          <find-fuel-specific-filters/>
        </div>

        <div v-if="!isMobileView && !isNpsFunded" class="afdc-col-md-auto">
          <router-link v-bind:to="{ name: 'FindRouteStations' }" event="" v-on:click.native.prevent="clickToggleMode('toggle')" class="afdc-switch-find-type">
            <div id="afdc-switch-find-type">
              <img src="../assets/images/icon-switch-find-type.png" alt="">
              <div id="afdc-switch-find-type-text">{{ $t('Map a Route') }}</div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FindFuelFilter from '@/components/FindFuelFilter.vue';
import NpsFilter from '@/components/NpsFilter.vue';
import FindFuelSpecificFilters from '@/components/FindFuelSpecificFilters.vue';
import FindMixin from '@/lib/FindMixin';
import syncInputRouteQuery from '@/lib/syncInputRouteQuery';

export default {
  mixins: [
    FindMixin,
  ],

  components: {
    FindFuelFilter,
    FindFuelSpecificFilters,
    NpsFilter,
  },

  data() {
    return {
      queryLocationLive: null,
    };
  },

  computed: {
    queryLocation: syncInputRouteQuery('location'),

    isNpsFunded() {
      return this.$store.getters.isNpsFunded;
    },

    npsWidthClass() {
      if (this.isNpsFunded) {
        return 'afdc-col-md-4';
      }
      return 'afdc-col-md-6';
    },

    npsFilters() {
      return this.$store.getters.getFiltersNps;
    },

    queryAccess: syncInputRouteQuery('access'),

    isMobileView() {
      return this.$store.getters.isMobileView;
    },

  },
  watch: {

    queryLocation: {
      immediate: true,
      handler: 'setQueryLocationLive',
    },
  },

  methods: {
    // Have a "live" version of the location inputs (updated on every
    // keystroke), but only sync it with the query params on "change" events
    // (similar to Vue's normal "lazy" model syncing). This allows us to have
    // the live version (unlike Vue's lazy handling), which we can use for
    // determining whether the "x" should be shown, but still defer submission
    // until the actual change event (so we're not searching on every
    // keystroke).
    setQueryLocationLive() {
      if (this.queryLocation !== this.queryLocationLive) {
        this.queryLocationLive = this.queryLocation;
      }
    },
    triggerQueryLocationChange() {
      this.queryLocation = this.queryLocationLive;
    },

    clearLocation() {
      this.queryLocation = null;
    },
  },
};
</script>

<style lang="scss">

</style>
